import { render, staticRenderFns } from "./promotionCell.vue?vue&type=template&id=fa037638&scoped=true"
import script from "./promotionCell.vue?vue&type=script&lang=js"
export * from "./promotionCell.vue?vue&type=script&lang=js"
import style0 from "./promotionCell.vue?vue&type=style&index=0&id=fa037638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa037638",
  null
  
)

export default component.exports